import { render, staticRenderFns } from "./ThePlatform.vue?vue&type=template&id=2b620c69&scoped=true"
import script from "./ThePlatform.vue?vue&type=script&lang=js"
export * from "./ThePlatform.vue?vue&type=script&lang=js"
import style0 from "./ThePlatform.vue?vue&type=style&index=0&id=2b620c69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b620c69",
  null
  
)

export default component.exports